import { toast } from "../ui/sonner";

/* 财务确认收款后 后端自动回执邮件结果 → 统一提示（三处入口：CRM 合同期 / 项目财务付款计划 / 变更单确认收款） */
export function receiptToast(r, zh) {
  if (!r) return;
  if (r.sent) toast.success(zh ? `收款回执已自动邮件客户 ${r.to}（防伪码 ${r.code || "—"}）` : `Receipt auto-emailed to ${r.to} (code ${r.code || "—"})`, { id: "auto-receipt", duration: 7000 });
  else if (r.skipped === "already_sent") toast.info(zh ? `该期回执此前已邮件 ${r.to || "客户"}，不重复发送` : `Receipt was already emailed to ${r.to || "customer"}; not resent`, { id: "auto-receipt" });
  else if (r.skipped === "no_email") toast.warning(zh ? "客户未登记邮箱，回执未自动发出（可在详情页预览 / 下载回执）" : "Customer has no email on file — receipt not sent (preview / download from the detail page)", { id: "auto-receipt" });
  else if (r.skipped === "email_not_configured") toast.warning(zh ? "邮件服务未配置，回执未自动发出" : "Email service not configured — receipt not sent", { id: "auto-receipt" });
  else if (r.error) toast.error(zh ? `回执邮件发送失败：${r.error}` : `Receipt email failed: ${r.error}`, { id: "auto-receipt" });
}
